import React from 'react';
import './SkanetrafikenSearch.scss';
import Autocomplete from 'Components/Shared/Autocomplete/Autocomplete';

interface IProps {
  locationOptions: string[];
  onLocationChange: (value: string) => void;
  onLocationSelect: (value: string) => void;
}

const SkanetrafikenSearch: React.SFC<IProps> = ({
  locationOptions,
  onLocationChange,
  onLocationSelect,
}) => (
  <div className='skanetrafiken-search'>
    <Autocomplete 
      iconType='environment-o'
      triggerStyle='autocomplete-trigger'
      options={ locationOptions }
      placeholder={ {
        displayName: 'Ort du vill åka från...',
        formattedName: 'order.skanetrafiken.search.placeholder',
      } }
      onSelect={ onLocationSelect }
      onChange={ onLocationChange }
    />
  </div>
);

export default SkanetrafikenSearch;


// WEBPACK FOOTER //
// ./src/components/PickSkanetrafiken/SkanetrafikenSearch/SkanetrafikenSearch.tsx